var map = {
	"./Day-3-JK-10.jpg": 5204,
	"./RunYYC2024_CalgaryMarathon-931015296-scaled.jpg": 7710,
	"./banner-1.jpg": 4167,
	"./banner-2.jpg": 2148,
	"./banner-5.jpg": 9555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7321;